module.exports = __webpack_public_path__ + "img/numbers.artics.e57bcb8b.svg";